import { Button } from "@msuite/ui/button";
import { Icon, icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { Menu } from "@msuite/ui/menu";
import { type CellContext, RowActionsWrapper, useDataTableContext } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import type { ProjectMeasurement } from "@msuite/utils/types";
import { client } from "@/hono";

export function RowActions({ cell }: CellContext<ProjectMeasurement, "actions">) {
	/** Hooks */
	const { t } = useTranslation();
	const context = useDataTableContext();

	/** Functions */
	async function handleOnResetStatement() {
		const response = await client.measurements[":projectId"].measurements[
			":ticketAssignmentId"
		].statement.$delete({
			param: {
				projectId: cell.row.original.projectId,
				ticketAssignmentId: cell.row.original.id,
			},
		});
		await responseHandler(response);
		await context.refetch?.();
		context.handleOnSetItemRenderId();
		context.table.resetRowSelection();
	}

	/** Render */
	return (
		<RowActionsWrapper to={null}>
			<Menu
				items={() => [
					{
						label: t("general.reset"),
						icon: icon("RefreshCcw"),
						onClick: handleOnResetStatement,
						isDanger: true,
					},
				]}
			>
				<Button
					icon={<Icon name="EllipsisVertical" />}
					variant="ghost"
				/>
			</Menu>
		</RowActionsWrapper>
	);
}
